import { jsxs as m, jsx as h } from "react/jsx-runtime";
const t = ({ size: v = 24, ...l }) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: v,
    height: v,
    viewBox: "0 0 32 32",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ h("rect", { x: "-5.332", width: "42.67", height: "32", fill: "white" }),
      /* @__PURE__ */ h(
        "path",
        {
          d: "m-0.332 0 11.07 8.209v-8.209zm21.73 0v7.996l10.73-7.996zm15.93 4.133-8.76 6.533h8.76zm-42.67 0.1348v6.398h8.592zm0 17.07v6.666l8.949-6.666zm33.77 0 8.898 6.6v-6.6zm-17.7 2.678-10.67 7.988h10.67zm10.67 0.08203v7.906h10.6z",
          fill: "#012169"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          d: "m-5.332 0v2.801l10.51 7.865h3.977zm18.2 0v12.87h-18.2v6.4h18.2v12.73h6.4v-12.73h18.07v-6.4h-18.07v-12.87zm21.13 0-12.6 9.402v1.264h2.07l13.86-10.47v-0.1992zm-25.03 21.33-14.3 10.67h3.6l12.47-9.35v-1.316zm13.84 0 14.52 10.67v-2.666l-10.87-8z",
          fill: "#c8102e"
        }
      )
    ]
  }
);
export {
  t as RegionBritainIcon
};
